import React from 'react';
import { createUseStyles } from 'react-jss';
import { CancelIcon, PencilIcon, Theme } from '@spoiler-alert/ui-library';

const useStyles = createUseStyles(
  {
    pill: {
      border: `1px solid ${Theme.pillBorderColor}`,
      borderRadius: Theme.borderRadius,
      backgroundColor: Theme.pillBgColor,
      color: Theme.textColorPrimary,
      padding: [5, 8],
      fontSize: 10,
      display: 'inline-flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    pillAction: {
      cursor: 'pointer',
      marginLeft: 12,
      '&:hover $pillIcon': {
        fill: Theme.green,
      },
    },
    pillIcon: {
      height: 12,
      width: 12,
      fill: Theme.pillIconFillColor,
    },
  },
  { name: 'EmailPill' },
);

interface EmailPillProps {
  email: string;
  onRemove: (email: string) => void;
  onEdit: (email: string) => void;
  style?: React.CSSProperties;
}

const EmailPill: React.FC<EmailPillProps> = ({ email, onRemove, onEdit, style }) => {
  const classes = useStyles();

  const handleRemove = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.stopPropagation();
    onRemove(email);
  };

  const handleEdit = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.stopPropagation();
    onEdit(email);
  };

  return (
    <span className={classes.pill} style={style} data-element="pill">
      <span>{email}</span>
      <span className={classes.pillAction} data-element="pill-remove" onClick={handleEdit}>
        <PencilIcon className={classes.pillIcon} />
      </span>
      <span className={classes.pillAction} data-element="pill-remove" onClick={handleRemove}>
        <CancelIcon className={classes.pillIcon} />
      </span>
    </span>
  );
};

export default EmailPill;
